import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import privacyHtml from '@/marketing/privacy.html?raw';
import { prepareMarketingHtml, makeInternalLinkHandler } from '@/lib/marketing';

export default function Privacy() {
  const navigate = useNavigate();
  const html = useMemo(() => prepareMarketingHtml(privacyHtml), []);
  const onClick = useMemo(() => makeInternalLinkHandler(navigate), [navigate]);

  useEffect(() => {
    document.title = 'Privacy Policy — 18Gimmies';
  }, []);

  return <div onClick={onClick} dangerouslySetInnerHTML={{ __html: html }} />;
}
